var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradesBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "url(#pattern0_3404_11)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3404_11",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3404_11",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3404_11",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAD5klEQVR4nO2dO2gUURSGj+83ojY2sbHxgWghWIkKFoKiEph7NiIELLQRu2AhGGMlPiMWPgo7C4OgaMw9my1iaSERNIKFWChYSMBHIiirRmaUTe7s5jGP9cy99/xwi2R3ZrLfd8+5s5NZFkAikUgkEolEIpFIsqakNwLqK6BoCJQeBaQx3qHP+CE16JkPSl8DpJ/80MkzCSF8pAo/aPJUwt+ZXwDI5KGEqOcXse2QJxIUdfNDpWRD6XPgTJBeFW6Go0+VgHqEHzqNj+hvopP+VAI3cGwgwCsJRRXgjYQiC/BCQtEFOC/BBgFOS7BFgLMSbBLgpATbBDgnwUYBTkmwVYAzEmwW4IQE2wVYL8EFAVZLcEWAtRJcEmClBNcEWCfBRQFJJLCHGzg2EchMJLCHGzg2Gch0EtjDDRz/A5CpJLCHGzg6KFwEkAgA7pktFUD8cKUFET9gWQOo2IM93ABQBPBDQKmA/CAoeg9Bz5xahbUPLATUn9hBe9OCFJ1tcIwb7KD9EKB/A/atrTtGqbyNHbQfAujJFMd5wQ7beQFBuX3y4+iOXEGJgLr2MwLBwNIaIEWbAaml9nPQuxpQV0VA0ypA3zb2q+h8NOuN3+lHIqB5ArbX9tnZORuUfgeKBmNtqFUENEWAfgswNmsC6J3j60Lfhtgn8j/KGpB/BZyKzfRbtceU7oq1pqsiIE8Bin5BUFljznI9POHxN0Z1BI83JTrbSZqsZ1f2CdBlc3/6QN1zSv1bY895LgLyEhDotpjQuw2q5JLxnJI+IQJyEaA/w76Hi2v72v9gGSB9ayDgg3GB7mBlFSB9lxaUvQKuGzM7fCc8+VqxK9aG7mXq1Vkr14k1oFTeZuwr6FkEh3pXNBx7+hYYzy3pvSIgm4DXmcTvGJgbtSapgNT9vwOyJrpcIS0oDfxqdHFtYpBOg9I3pxxIx81t+teLgDSzP7yoZsJvid6QTb/dKBwuLzG2VfqpLMLJK6A19bX+QKuYgGO5ndGkGexJDn+47oxG0WCC7e8b2waV5Q3fO4iAydoIdRsA22hdQlg/IKCVpkB9RwTMuIWUt8TgdSWGF9CR2D52iwDOPoyyBvCDQFkD/Bzs4QaAIoAfAkoF8INApsEebgAoAvghoFQAPwhkGuzhBoAigB8CSgXwg0CmwR6kr+wQkGko+sKNP7yWP8QOArmGfsmNP7wUfNnfCtAXuPFDdPu4VV9jRXnN/mr0z6RCJO0t42jxCCu/MDn6bB4o3e8R/HL0mguVSEL4pW4ZPkiHRR+6Gs38wsGPrwnh7eThGULRvmMMU0Ef+fdaLkY3gkkkEolEIpFIJBIJZMsfOOFa3G/aEHcAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradesBlue);
export default __webpack_public_path__ + "static/media/grades-blue.7aa055f0afd75554a513355ace4b7606.svg";
export { ForwardRef as ReactComponent };